import { DATA_GRID_PLACEHOLDER } from 'components/DataGrid';
import Tooltip from 'components/Tooltip';

const getAllLanguages = (
  supportedLanguages: string[],
  unsupportedLanguages: string[],
): string[] => {
  return [...(supportedLanguages || []), ...(unsupportedLanguages || [])];
};

const renderBadges = (
  allLanguages: string[],
  supportedLanguages: string[],
): JSX.Element[] => {
  const badges = allLanguages.slice(0, 4).map((lang, index) => (
    <a
      key={index}
      className={`badge ${
        supportedLanguages.includes(lang) ? 'badge-primary' : 'badge-warning'
      }`}
      style={{ margin: '0 5px 2px 0', color: '#ffffff' }}
    >
      {lang}
    </a>
  ));

  if (allLanguages.length > 4) {
    badges.push(
      <span
        key="more"
        style={{
          lineHeight: '12px',
          fontSize: '16px',
          fontWeight: 'bolder',
          letterSpacing: '2px',
        }}
      >
        ...
      </span>,
    );
  }

  return badges;
};

const renderTooltipContent = (
  supportedLanguages: string[],
  unsupportedLanguages: string[],
): JSX.Element => {
  return (
    <>
      {supportedLanguages.length > 0 ? (
        <div style={{ padding: '0px 2px 0px 2px' }}>
          <strong>Languages Scanned: </strong>
          {supportedLanguages.map((lang, index) => (
            <span key={index}>
              {lang}
              {index < supportedLanguages.length - 1 ? ', ' : ''}
            </span>
          ))}
        </div>
      ) : null}
      {unsupportedLanguages.length > 0 ? (
        <div
          style={{
            backgroundColor: '#ffc107',
            padding: '0px 2px 0px 2px',
          }}
        >
          <strong>Languages Not Scanned: </strong>
          {unsupportedLanguages.map((lang, index) => (
            <span key={index}>
              {lang}
              {index < unsupportedLanguages.length - 1 ? ', ' : ''}
            </span>
          ))}
        </div>
      ) : null}
    </>
  );
};

// Component
const LanguageBadges = ({
  supportedLanguages = [],
  unsupportedLanguages = [],
}: {
  supportedLanguages?: string[];
  unsupportedLanguages?: string[];
}) => {
  const allLanguages = getAllLanguages(
    supportedLanguages,
    unsupportedLanguages,
  );

  if (allLanguages.length > 0) {
    const badges = renderBadges(allLanguages, supportedLanguages);

    if (allLanguages.length > 4) {
      return (
        <Tooltip
          tooltip={renderTooltipContent(
            supportedLanguages,
            unsupportedLanguages,
          )}
        >
          <div className="d-flex flex-wrap align-center">{badges}</div>
        </Tooltip>
      );
    }

    return <>{badges}</>;
  }
  return <span style={{ textAlign: 'center' }}>{DATA_GRID_PLACEHOLDER}</span>;
};

export default LanguageBadges;
